module.exports = __webpack_public_path__ + "img/footy_logo_dark.4ff4b841.png";